import { useTranslation } from 'next-i18next'
import { useState } from 'react'

import { useBodyNoScroll } from '@src/device/hooks/useBodyNoScroll'
import { Button, BUTTON_TYPES, Modal } from '@src/quince-components/src'

import styles from './address-edit-confirmation-modal.module.scss'

interface AddressEditConfirmationModalProps {
  open: boolean
  onDone: () => void | Promise<void>
}

export const AddressEditConfirmationModal = ({ open, onDone }: AddressEditConfirmationModalProps) => {
  const { t } = useTranslation('common')
  const [isSubmitting, setIsSubmitting] = useState(false)

  useBodyNoScroll(open)

  const handleDone = async () => {
    if (isSubmitting) {
      return
    }
    setIsSubmitting(true)
    try {
      await onDone()
    } catch {
      // onDone owns success/error handling; swallow so a rejection can't surface as an
      // unhandled rejection, and re-enable the button below so the action can be retried.
    } finally {
      setIsSubmitting(false)
    }
  }

  return (
    <Modal
      closeOnBGClick={false}
      open={open}
      onClose={() => {
        void handleDone()
      }}
      className={styles.modal}
      modalWrapperClassName={styles.modalWrapper}
    >
      <div className={styles.container}>
        {t('address_edit_confirmation')}
        <Button
          type={BUTTON_TYPES.SECONDARY}
          className={styles.doneButton}
          onClick={() => {
            void handleDone()
          }}
          showLoader={isSubmitting}
          disabled={isSubmitting}
        >
          {t('done')}
        </Button>
      </div>
    </Modal>
  )
}
